import React from 'react';
import { Layout } from 'antd';
import Footer from '../../../../footer/Footer';
import Header from '../../../../header/Header';
import Loading from '../../../../loading/Loading';
import './PublicDesktopLayout.scss';
import * as constants from '../../../../../utils/constants/constant';
import { withRouter } from 'react-router-dom';

const isViewFullPage = (pathname) => {
  return (
    pathname === constants.routes.LOGIN ||
    pathname === constants.routes.FORGOT_PASSWORD
  );
};

const PublicDesktopLayout = (props) => {
  const { children } = props;
  return (
    <div className='app-container public-layout desktop-layout'>
      <Layout
        style={{ minWidth: 'min-content' }}
        className={`${
          isViewFullPage(props.location.pathname) ? 'full-page' : ''
        }`}
      >
        <Header />
        <Layout.Content
          className='content-container'
          style={{ minWidth: 'min-content' }}
        >
          <div>
            <Loading />
            {children}
          </div>
        </Layout.Content>
        <Footer />
      </Layout>
    </div>
  );
};

export default withRouter(PublicDesktopLayout);
